import type { Area } from 'react-easy-crop';

const loadImage = (src: string): Promise<HTMLImageElement> =>
  new Promise((resolve, reject) => {
    const image = new Image();
    image.onload = () => resolve(image);
    image.onerror = reject;
    image.src = src;
  });

export const cropImage = async (image: string, area: Area): Promise<string> => {
  try {
    const loadedImage = await loadImage(image);

    const canvas = document.createElement('canvas');
    canvas.width = area.width;
    canvas.height = area.height;

    const context = canvas.getContext('2d');
    if (!context) return image;

    context.drawImage(
      loadedImage,
      area.x,
      area.y,
      area.width,
      area.height,
      0,
      0,
      area.width,
      area.height
    );

    return canvas.toDataURL('image/png');
  } catch {
    return image;
  }
};
